module.exports = __webpack_public_path__ + "285f4219ea6243cef8f30b9fcbd04711.fbx";